import { render, staticRenderFns } from "./CardCollectionGridCell.vue?vue&type=template&id=1e638069&scoped=true"
import script from "./CardCollectionGridCell.vue?vue&type=script&lang=js"
export * from "./CardCollectionGridCell.vue?vue&type=script&lang=js"
import style0 from "./CardCollectionGridCell.vue?vue&type=style&index=0&id=1e638069&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e638069",
  null
  
)

export default component.exports